import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  class: "container-wide w-100 flex-shrink-1 flex-grow-1 d-flex flex-column card bg-white p-5",
  style: {"min-height":"0"}
}
const _hoisted_2 = { class: "flex-shrink-0 d-flex flex-row justify-content-between align-items-center mb-4" }
const _hoisted_3 = { class: "ml-auto" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus" }, null, -1)
const _hoisted_7 = {
  class: "flex-shrink-1 flex-grow-1",
  style: {"min-height":"0"}
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "flex-grow-1" }
const _hoisted_10 = { class: "m-0" }
const _hoisted_11 = { class: "font-weight-bold" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "m-0" }
const _hoisted_14 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_translate = _resolveComponent("translate")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InfiniteList = _resolveComponent("InfiniteList")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.users.call?.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.rpcClient.isInternalUser && _ctx.role?.startsWith('ORGANIZATION_'))
        ? (_openBlock(), _createBlock(_component_Dropdown, {
            key: 0,
            class: "flex-grow-1 mr-4",
            modelValue: _ctx.organizationId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.organizationId) = $event)),
            loading: _ctx.organizations.call?.loading,
            options: (_ctx.organizations.data || []),
            "option-label": "name",
            "option-value": "id",
            label: _ctx.i18n.$gettext('Unternehmen'),
            filter: "",
            "show-clear": ""
          }, null, 8, ["modelValue", "loading", "options", "label"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.rpcClient.isSystemAdmin && _ctx.role === 'ORGANIZATION_USER')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push('/benutzer/anlage')))
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createTextVNode("  "),
                _createVNode(_component_translate, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Externen Benutzer anlegen")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.rpcClient.isOrganizationAdmin && _ctx.role === 'ORGANIZATION_USER')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push('/benutzer/anlage')))
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createTextVNode("  "),
                _createVNode(_component_translate, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Benutzer anlegen")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.rpcClient.isSystemAdmin && _ctx.role === 'SYSTEM_USER')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 2,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.router.push('/benutzer/intern/anlage')))
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _createTextVNode("  "),
                _createVNode(_component_translate, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Internen Benutzer anlegen")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_InfiniteList, {
        class: "h-100 w-100",
        "get-all-items": _ctx.sortAndFilterUtil.sort(_ctx.users.data || [], [ 'email:asc' ]).filter(u => !_ctx.orgIdFromQueryOrIntern || u.organizationId === _ctx.orgIdFromQueryOrIntern),
        "id-property": 'email',
        "auto-scroll-at-start": ""
      }, {
        element: _withCtx((props) => [
          _createElementVNode("div", {
            class: "card clickable d-flex flex-row align-items-center p-2 mb-2",
            style: {"margin":"0 2px"},
            onClick: ($event: any) => (_ctx.openUser(props.item.email))
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.displayName(props.item)), 1),
                (props.item.state !== 'ACTIVE')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                      _createTextVNode(" ("),
                      _createVNode(_component_translate, null, {
                        default: _withCtx(() => [
                          _createTextVNode("inaktiv")
                        ]),
                        _: 1
                      }),
                      _createTextVNode(")")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", _hoisted_13, _toDisplayString(props.item.email), 1)
            ]),
            (_ctx.rpcClient.isSystemAdmin && props.item.email)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (props.item.state === 'ACTIVE')
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "mr-2",
                        onClick: _withModifiers(($event: any) => (_ctx.setUserState(props.item, 'DISABLED')), ["stop"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Deaktivieren")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : (_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        class: "mr-2",
                        onClick: _withModifiers(($event: any) => (_ctx.setUserState(props.item, 'ACTIVE')), ["stop"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Freischalten")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])),
                  ((!props.item.state || props.item.state === 'ACTIVE') && props.item.twoFactorEnabled !== null)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 2,
                        class: "mr-2",
                        onClick: _withModifiers(($event: any) => (_ctx.reset2FA(props.item)), ["stop"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("2FA Zurücksetzen")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (props.item.authenticationBackend !== 'ldap' && (!props.item.state || props.item.state === 'ACTIVE'))
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 3,
                        class: "mr-2",
                        onClick: _withModifiers(($event: any) => (_ctx.resetPW(props.item)), ["stop"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Passwort Zurücksetzen")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_8)
        ]),
        _: 1
      }, 8, ["get-all-items"])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#breadcrumbs" }, [
      _createVNode(_component_Breadcrumb, {
        home: { icon: 'pi pi-home', to: '/' },
        model: _ctx.breadcrumbs
      }, null, 8, ["model"])
    ]))
  ]))
}